import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = ["src"]

import {computed} from "vue";
import Icon from "../Icon/Icon.vue";
import {IconName} from "../Icon/icons";

interface Props {
  src: string|null;
  placeholderIcon: IconName;
  border?: boolean;
  size?: 'small'|'medium';
}


export default /*@__PURE__*/_defineComponent({
  __name: 'Image',
  props: {
    src: {},
    placeholderIcon: {},
    border: { type: Boolean },
    size: {}
  },
  setup(__props: any) {

const props = __props;

const sizeClass = computed(() => {
  return props.size === 'small' ? 'size-10' : 'size-14';
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass([
      sizeClass.value, 'rounded-lg overflow-hidden', 
      {'border-4 border-tile box-content': props.border}, 
    ])
  }, [
    (props.src)
      ? (_openBlock(), _createElementBlock("img", {
          key: 0,
          src: props.src,
          class: "bg-tile"
        }, null, 8 /* PROPS */, _hoisted_1))
      : (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: _normalizeClass([
      sizeClass.value, 'rounded flex-shrink-0',
      'flex items-center justify-center',
      'accent'
    ])
        }, [
          _createVNode(Icon, {
            name: props.placeholderIcon
          }, null, 8 /* PROPS */, ["name"])
        ], 2 /* CLASS */))
  ], 2 /* CLASS */))
}
}

})